import { BreadCrumbItem, BreadCrumbs } from '@eventbrite/breadcrumbs-infra';
import React from 'react';
import styles from './BreadcrumbsSection.module.scss';

export interface Breadcrumb {
    title: string;
    relative_url: string;
    absolute_url: string;
}

export interface BreadcrumbsProps {
    breadcrumbs?: Breadcrumb[];
    containerClasses?: string;
}

export const ThingsToDoBreadcrumbs = ({
    breadcrumbs = [],
    containerClasses = 'discover-breadcrumbs',
}: BreadcrumbsProps) => {
    const breadcrumbItems = React.useMemo<BreadCrumbItem<{}>[]>(() => {
        const items: BreadCrumbItem<{}>[] = breadcrumbs.map((breadcrumb) => {
            return {
                value: breadcrumb.relative_url,
                display: breadcrumb.title,
            };
        });
        return items;
    }, [breadcrumbs]);

    return (
        <BreadCrumbs
            containerClasses={containerClasses}
            items={breadcrumbItems}
            separator={<span className={styles.breadcrumbSeperator}>/</span>}
        >
            {(item: BreadCrumbItem<{}>) => (
                <a
                    href={item.value}
                    data-testid="breadcrumb-item"
                    title={item.display.toString()}
                >
                    {item.display}
                </a>
            )}
        </BreadCrumbs>
    );
};
